// @flow
import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {
   formattedHotlinePhone,
   hotlineEmail,
   hotlinePhone,
} from '../../constants/CoordsConstants';
import MailIcon from '../../ressources/images/icons/mail.inline.svg';
import FormIcon from '../../ressources/images/icons/form.inline.svg';
import PhoneIcon from '../../ressources/images/icons/phone.inline.svg';
import './DeviceSelectionFooter.less';

export const DeviceSelectionFooter = (language) => (
   <div>
      <footer className="device-selection-footer">
         <hr />
         <div className="device-selection-footer__list">
            <div className="device-selection-footer__item">
               <FormattedMessage id="footer.use-smartphone" tagName="h1" />
               <FormattedMessage
                  id="footer.download-luxtrust-mobile"
                  tagName="p"
               />
               <div className="device-selection-footer__link">
                  <a href={`https://www.luxtrust.lu/${language}/management`}>
                     <FormattedMessage id="footer.know-more" />
                  </a>
               </div>
            </div>
            <div className="device-selection-footer__item">
               <FormattedMessage
                  id="footer.not-yet-bilnet-access"
                  tagName="h1"
               />
               <FormattedMessage
                  id="footer.fill-ask-connexion-online"
                  tagName="p"
               />
               <div className="device-selection-footer__link">
                  <a
                     href={`https://finance.bil.com/BilNetFinancePlugin/Formulaires.mvc/FormulaireConnexion?lang=${language}`}>
                     <FormattedMessage id="footer.ask-connexion" />
                  </a>
               </div>
            </div>
            <div className="device-selection-footer__item">
               <FormattedMessage id="footer.technical-issue" tagName="h1" />
               <FormattedMessage id="footer.hotline-help" tagName="p" />

               <div className="device-selection-footer__link">
                  <MailIcon className="device-selection-footer__mail-icon" />
                  <a href={`mailto:${hotlineEmail}`}>{hotlineEmail}</a>
               </div>

               <div className="device-selection-footer__link">
                  <FormIcon />
                  <a
                     href={`https://finance.bil.com/BilNetFinancePlugin/Formulaires.mvc/FormulaireTechnique?lang=${language}`}>
                     <FormattedMessage id="footer.technical-form" />
                  </a>
               </div>

               <div className="device-selection-footer__link">
                  <PhoneIcon />
                  <a href={`tel:${hotlinePhone}`}>{formattedHotlinePhone}</a>
               </div>
               <div className="device-selection-footer__schedule">
                  <FormattedMessage id="footer.hotline-schedule" />
               </div>
            </div>
         </div>
      </footer>
   </div>
);
